'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["property", "onInsert", "fetchPaths", "dataTokenConfig"];
import PopoverContent from 'data-token-picker/components/PopoverContent';
import { TOKEN_EDIT } from 'data-token-picker/constants/PickerModes';
import { RequestStatus } from '../../api/constants';
import { usePaths } from '../personalize/hooks/usePaths';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function DataTokenPopoverBodyEdit(_ref) {
  let {
      property,
      onInsert,
      fetchPaths,
      dataTokenConfig
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const settingsLink = dataTokenConfig.isEmail ? rest.emailSettingsLink : rest.publishingSettingsLink;
  const [{
    categories,
    fieldsByCategory
  }, pathsRequestStatus] = usePaths(fetchPaths, dataTokenConfig);
  const allowEmptyFallbacks = dataTokenConfig.allowEmptyFallbacks === undefined ? true : dataTokenConfig.allowEmptyFallbacks;
  const {
    category,
    field,
    subCategory,
    fallback,
    hasDataSensitivity
  } = property || {};
  const _field = subCategory ? `${field}.${subCategory}` : field;
  const propertiesLoading = pathsRequestStatus === RequestStatus.PENDING || pathsRequestStatus === RequestStatus.UNINITIALIZED;
  if (propertiesLoading) {
    return /*#__PURE__*/_jsx(View, {
      inlineSize: "325px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        minHeight: 300
      })
    });
  }
  return /*#__PURE__*/_jsx(Fieldset, {
    _size: "small",
    children: /*#__PURE__*/_jsx(PopoverContent, Object.assign({
      mode: TOKEN_EDIT,
      category: category,
      categories: categories,
      field: hasDataSensitivity ? undefined : _field,
      fieldsByCategory: fieldsByCategory,
      fallback: fallback,
      allowEmptyFallbacks: allowEmptyFallbacks,
      hideFallbacks: dataTokenConfig && dataTokenConfig.hideFallbacks,
      onConfirm: onInsert,
      settingsLink: settingsLink
    }, rest))
  });
}
DataTokenPopoverBodyEdit.displayName = 'DataTokenPopoverBodyEdit';
export default DataTokenPopoverBodyEdit;